import { EntityDetailData, EntityDetailValueDto, EntityDto } from '@/apiClient';
import {
  MembershipStart,
  MembershipType,
} from '@/components/formBuilder/fieldConfig/constants';
import { MembershipInfoValue } from '@/components/formBuilder/form/form-fields/MembershipInfo/ChangeAndRenewMembershipModal/constants';
import { parseJson } from '@/lib/common';
import { ENTITY_DETAIL_NAME, OptionType } from '@/model/form-builder';
import { v4 as uuid } from 'uuid';

export const convertEntityToObject = (entity?: EntityDto | null) => {
  const objectByNames: Record<string, any> = {};
  const objectByIds: Record<string, any> = {};
  const objectAdditionalInfoByNames: Record<string, any> = {};
  if (entity) {
    (entity.entityDetailValues || []).forEach((edv) => {
      objectByNames[edv.entityDetailName!] = edv.value;
      objectAdditionalInfoByNames[edv.entityDetailName!] = edv.additionalInfo;
      objectByIds[edv.entityDetailId!] = edv.value;
    });
  }
  return {
    objectByNames,
    objectByIds,
    objectAdditionalInfoByNames,
  };
};

export const getMembershipConfigFromEntityDetailConfigOptions = (
  options: OptionType[],
) => {
  const membershipTypes =
    options.map((option) => {
      const data = parseJson(option.data, {});

      return {
        id: uuid(),
        name: option.label,
        value: option.value,
        order: option.sortOrder,
        annualPrice: !isNaN(data?.annualPrice) ? +data?.annualPrice : 0,
        isArchived: option.isArchived || false,
      } as MembershipType;
    }) || [];

  const membershipStart: MembershipStart = {};
  if (options.length > 0) {
    const data = parseJson(options[0].data, {});
    membershipStart.startDate = data.startDate
      ? new Date(data.startDate)
      : null;
    membershipStart.renewalPeriod = data.renewalPeriod;
    membershipStart.gracePeriod = data.gracePeriod;
  }

  return {
    membershipTypes,
    membershipStart,
  };
};

export const getMembershipInfoFromEntity = (
  entity: EntityDto,
  entityDetail?: EntityDetailData,
) => {
  const entityObjects = convertEntityToObject(entity);
  const membershipJsonValue =
    entityObjects.objectByNames[ENTITY_DETAIL_NAME.MEMBERSHIP];
  const membershipInfo = parseJson(
    membershipJsonValue,
    {},
  ) as MembershipInfoValue;

  const { membershipTypes } = getMembershipConfigFromEntityDetailConfigOptions(
    (entityDetail?.entityDetailConfig?.options || []) as OptionType[],
  );
  membershipInfo.Membership = membershipTypes.find(
    (m) => m.value === membershipInfo.MembershipValue,
  );
  return membershipInfo;
};

export const convertEntityWithLatestDetailValues = (
  entity: EntityDto | null,
) => {
  if (!entity) {
    return null;
  }
  const entityDetailValues: EntityDetailValueDto[] = [];
  (entity.entityDetailValues ?? []).forEach((edv) => {
    const existed = entityDetailValues.some(
      (it) => it.entityDetailId === edv.entityDetailId,
    );
    if (!existed) {
      let latestEdv: EntityDetailValueDto | null = null;
      entity.entityDetailValues?.forEach((it) => {
        if (
          it.entityDetailId === edv.entityDetailId &&
          (latestEdv?.entityDetailValueId || 0) < it.entityDetailValueId!
        ) {
          latestEdv = it;
        }
      });
      if (latestEdv) {
        entityDetailValues.push(latestEdv!);
      }
    }
  });

  return {
    ...entity,
    entityDetailValues,
  } as EntityDto;
};
